import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';
import { Formik, FormikErrors, FormikHelpers, useFormikContext } from '../../lib/formik/Formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { FormControl } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { showError } from '../../redux-store/actions/auth';
import MFCheckbox from '../../lib/formik/Checkbox';
import UseRadioGroup, { UseRadioGroupTransparent } from '../../lib/formik/Radio';
import { MFTextField } from '../../lib/formik';
import { useHistory, useParams, useRouteMatch } from 'react-router';
// import { riskProfileScheme } from '../../utils/schema';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  profileType,
  RiskProfile,
  RiskProfileGroup,
  RiskProfileMaster,
  RiskProfileMasterType,
} from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import {
  applicationComparison,
  applyRoleBasedStatus,
  findRiskTolerance,
  getAge,
  getRiskAgeValue,
  getScore,
  isModuleAllowed,
  saveForLater,
} from '../../utils/utilityFunctions';
import { updateApplication } from '../../redux-store/actions/application';
import { AMC_APPROVER_CHECK_FOR_INDIVIDUAL, ONBOARDING_DEMAT_DETAILS, USER_ROLES } from '../../utils/constant';
import { useSnackbar } from 'notistack';
import { getRiskProfileGroups, riskProfileMasterData } from '../../redux-store/actions';
import { riskProfileDeclaration, riskProfileDonotWish } from '../../utils/declaration';
import { fontSize } from '@mui/system';
import { ConfirmationDialog } from '../commonComponents';
import theme from '../../themes';
import MFSelectField from '../../lib/formik/SelectField';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import dayjs, { Dayjs } from "../../utils/dayjs";

export type updatedRiskProfile = RiskProfile &
  RiskProfileMasterType & {
    otherValue?: string;
    InvestmentGoal?: string[];
    scoreCal?: number;
    answerText?: string;
    questionText?: string;
    isActive?: boolean;
  };

export type Values = {
  wishToAddRiskProfile: boolean;
  riskProfileDeclaration: boolean;
  riskProfileGroup?: string;
  riskProfileDeclarationDate?: Dayjs;
  riskProfileExpiryDate?: Dayjs;
  totalRiskProfileScore: number;
  riskprofiles: updatedRiskProfile[];
  saveType: string;
};

export const RiskProfileObj: updatedRiskProfile = {
  question: '',
  answer: '',
  scoreText: '',
  otherValue: '',
  key: '',
  displayText: '',
  InvestmentGoal: [],
  scoreCal: 0,
  answerText: '',
  questionText: ''
};

const todayDate = new Date();
const oneYearAhead = new Date(todayDate.getTime());
oneYearAhead.setFullYear(todayDate.getFullYear() + 1);
oneYearAhead.setDate(oneYearAhead.getDate() - 1);

const initialValues: Values = {
  wishToAddRiskProfile: false,
  riskProfileDeclaration: true,
  riskProfileGroup: "",
  riskProfileDeclarationDate: dayjs(),
  riskProfileExpiryDate: dayjs(oneYearAhead),
  totalRiskProfileScore: 0,
  riskprofiles: [],
  saveType: 'save and proceed',
};

function RiskDeclaration({
  data,
  values,
  setValues,
  setTotalScore,
  totalScore,
  disabled,
}: {
  data: updatedRiskProfile[];
  values: Values;
  setValues: FormikHelpers<Values>['setValues'];
  setTotalScore: any;
  totalScore: any;
  disabled: boolean;
}): JSX.Element {
  const [expanded, setExpanded] = React.useState<string | false>('');

  useEffect(() => {
    setExpanded(disabled ? '' : expanded);
  }, [disabled]);

  const _handleSelection = async (
    ind: number,
    selectedOptionObj: any,
    InvestmentGoal: string[],
    scoreCal: string | number
  ) => {
    const index = InvestmentGoal?.indexOf(
      `${selectedOptionObj.key}_${selectedOptionObj.score}` as string
    );
    const investmentGoalSelect =
      index === -1
        ? [...InvestmentGoal, `${selectedOptionObj.key}_${selectedOptionObj.score}`]
        : InvestmentGoal?.filter(
          (goal: any) => goal != (`${selectedOptionObj.key}_${selectedOptionObj.score}` as string)
        );

    const total = investmentGoalSelect?.includes(
      `${selectedOptionObj.key}_${selectedOptionObj.score}`
    )
      ? Number(scoreCal) + Number(selectedOptionObj.score)
      : Number(scoreCal) - Number(selectedOptionObj.score);

    setValues({
      ...values,
      riskprofiles: values.riskprofiles.map((risk, index) => {
        if (index === ind) {
          return {
            ...risk,
            answer: investmentGoalSelect?.toString().replace(/,/g, '*'),
            scoreText: total.toFixed(1)?.toString() || '',
            InvestmentGoal: investmentGoalSelect,
            scoreCal: total,
          };
        }
        return risk;
      }),
    });
  };

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <Box sx={{ width: '100%' }}>
      {data?.map((dataValues: any, ind: any) => {
        return (
          <>
            <Accordion
              sx={{ boxShadow: 'none', mb: 3, '&::before': { display: 'none' } }}
              key={ind}
              expanded={expanded === `panel${ind}`}
              onChange={handleChange(`panel${ind}`)}
              disabled={disabled}>
              <AccordionSummary
                sx={{
                  bgcolor: `${theme.palette.customColors.darkGrey}`,
                  borderRadius: '10px',
                  '&.Mui-expanded': { minHeight: 'unset' },
                  '& .MuiAccordionSummary-content': { '&.Mui-expanded': { my: 2 } },
                  '& .MuiAccordionSummary-expandIconWrapper': {
                    color: theme.palette.customColors.infoCardTitle, 
                  },
                  '&.Mui-focusVisible': {
                    border: `2px solid ${theme.palette.primary[500]}`,
                    offset: '2px',
                  },
                }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${ind}d-content`}
                id={`panel${ind}d-header`}>
                <Typography
                  id={`risk-profile-question-${ind}`}
                  sx={{
                    color: `${theme.palette.text.primary}`,
                    fontSize: 16,
                    fontWeight: 500,
                    fontFamily: `${theme.typography.fontFamily}`
                  }}>
                  {`${ind + 1}. ${dataValues.displayText} ${dataValues.required === 'true' ? '*' : ''
                    }`}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ pb: 0 }}>
                {['radio', 'multiSelectCheckBox'].includes(dataValues.questionType) && (
                  <>
                    {dataValues.isMultiselect === 'false' && (
                      <UseRadioGroupTransparent
                        name={`riskprofiles.${ind}.answer`}
                        aria-labelledby={`risk-profile-question-${ind}`}
                        items={dataValues.values.map((profile: any) => ({
                          label: profile.label,
                          value: profile.key,
                        }))}
                        onChange={(e) => {
                          let score;
                          setValues({
                            ...values,
                            riskprofiles: values.riskprofiles.map((risk, index) => {
                              if (index === ind) {
                                score = risk.values?.filter((risk) => {
                                  return risk.key === e.target.value;
                                })?.[0].score;
                                setTotalScore(totalScore + Number(score));
                                return {
                                  ...risk,
                                  answer: e.target.value,
                                  scoreText: score?.toString() || '',
                                  answerText: dataValues?.values?.find((obj: { [key: string]: any }) => obj?.key === e.target.value)?.label ?? ""
                                };
                              }
                              return risk;
                            }),
                          });
                        }}
                        sx={{
                          '& .MuiFormGroup-root': { flexDirection: 'column' },
                          '& .MuiFormControlLabel-label': { fontWeight: 400 },
                        }}
                      />
                    )}
                    {dataValues.isMultiselect === 'true' && (
                      <FormControl
                        component="fieldset"
                        role="group"
                        aria-labelledby={`risk-profile-question-${ind}`}
                        sx={{ width: '100%' }}>
                        {dataValues.values.map((risk: any) => {
                          return (
                            <FormControlLabel
                              key={`${dataValues.key}-${risk.key}`}
                              value={dataValues.key}
                              sx={{
                                width: '100%',
                                position: 'relative',
                                pb: 0,
                                ml: 0.2,
                                '.MuiFormLabel-root ': {
                                  color: 'primary.main',
                                  fontWeight: 600,
                                  mb: 0.5,
                                },
                                '.MuiFormControlLabel-root': {
                                  width: '100%',
                                  alignItems: 'flex-start',
                                  '.MuiTypography-root': {
                                    color: 'text.primary',
                                    fontWeight: 500,
                                    fontSize: 14,
                                    overflow: { xs: 'unset', md: 'hidden' },
                                    whiteSpace: { xs: 'unset', md: 'nowrap' },
                                    textOverflow: { xs: 'unset', md: 'ellipsis' },
                                    wordBreak: { xs: 'break-word', md: 'unset' },
                                  },
                                  '.MuiRadio-root,.MuiCheckbox-root ,.Mui-checked': {
                                    color: 'text.primary',
                                  },
                                  '.MuiRadio-root,.MuiCheckbox-root ': { p: 0, mr: 0.5 },
                                },
                                '.MuiAccordionDetails-root': {
                                  paddingTop: 0,
                                },
                                '.MuiAccordionSummary-content.Mui-expanded': {
                                  marginBottom: '10px',
                                },
                              }}
                              onChange={() => {
                                _handleSelection(
                                  ind,
                                  risk,
                                  dataValues.InvestmentGoal,
                                  dataValues.scoreCal
                                );
                              }}
                              control={
                                <Checkbox
                                  size="small"
                                  checked={dataValues.InvestmentGoal?.map((goal: any) =>
                                    goal.toString()
                                  ).includes(`${risk.key}_${risk.score}`)}
                                  inputProps={{
                                    'aria-labelledby': `risk-profile-question-${ind}`,
                                  }}
                                />
                              }
                              label={risk.label}
                              title={risk.label}
                            />
                          );
                        })}
                      </FormControl>
                    )}
                  </>
                )}
                {(values.riskprofiles[ind]?.answer === 'others' ||
                  (values.riskprofiles[ind].isMultiselect === 'true' &&
                    values.riskprofiles[ind]?.answer.includes('others'))) && (
                    <Grid xs={12} sm={6}>
                      <MFTextField
                        name={`riskprofiles.${ind}.otherValue`}
                        placeholder={`Please specify`}
                        sx={{
                          mb: 0,
                          '&.MuiInputBase-root': {
                            position: 'relative',
                            border: 0,
                            borderBottom: '1px solid #DDEAF3',
                            fontSize: 16,
                          },
                        }}
                        onChange={(e) => {
                          const removeAstricOrUnderscore = e.target.value
                            ?.replace('*', '')
                            ?.replace('_', '');
                          setValues({
                            ...values,
                            riskprofiles: values.riskprofiles.map((risk, index) => {
                              if (index === ind) {
                                return {
                                  ...risk,
                                  otherValue: removeAstricOrUnderscore,
                                };
                              }
                              return risk;
                            }),
                          });
                        }}
                      />
                    </Grid>
                  )}
              </AccordionDetails>
            </Accordion>
          </>
        );
      })}
    </Box>
  );
}

export const profiletext = (total: number, profileData: profileType[]): any => {
  let text;
  profileData?.map((profile) => {
    const min = Math.min(profile.minScore, profile.maxScore),
      max = Math.max(profile.minScore, profile.maxScore);
    if (total >= min && total <= max) {
      text = (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ fontFamily: `${theme.typography.fontFamily}`, fontSize: 16, fontWeight: 500, color: 'common.white', pr: 1 }}>
              {`Risk profile :`}
            </Typography>
            <Typography sx={{ fontFamily: `${theme.typography.fontFamily}`, fontSize: 18, fontWeight: 700, color: 'common.white' }}>
              {`${profile?.profileName}`}

            </Typography>

          </Box>
        </>
      );
    }
  });
  return text;
};

export const handleIntialSelect = (riskprofiles: RiskProfile[], riskProfileQuestion: string) => {
  let selectedValue: string[] = [];
  const longTermArr = riskprofiles?.find((a) => a.question === riskProfileQuestion);
  selectedValue = longTermArr?.answer.split('*') as unknown as string[];
  return selectedValue;
};

const isDateInRange = (dateToCheck: Dayjs, lowerLimit: Dayjs, upperLimit: Dayjs) => {
  return (
    dateToCheck.isSame(lowerLimit, 'day') ||
    dateToCheck.isSame(upperLimit, 'day') ||
    (dateToCheck.isAfter(lowerLimit, 'day') && dateToCheck.isBefore(upperLimit, 'day'))
  );
}

export default function riskProfile(): JSX.Element {
  const theme = useTheme();
  const [riskProfileData, setRiskProfileData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { enqueueSnackbar } = useSnackbar();
  const [riskProfileDataMaster, setRiskProfileDataMaster] = useState<RiskProfileMasterType[]>([]);
  const [profileData, setProfileData] = useState<profileType[]>([]);
  const [totalScore, setTotalScore] = useState(0);
  const [openPopup, setOpenPopup] = useState<{ riskProfileCheck: boolean } | null>(null);
  const [questionSetList, setQuestionSetList] = useState<RiskProfileGroup[]>([])
  const [isApiLoading, setApiLoading] = useState<boolean>(false)
  const { path: currentPath } = useRouteMatch();
  // Stores the original riskProfileGroup from application to detect if user switches back to the original group (reversal edge case)
  const [originalRiskProfileGroup, setOriginalRiskProfileGroup] = useState<string | null>(null);
  // Stores the previous riskprofiles from application so we can mark them isActive: false when group changes
  const [previousRiskProfiles, setPreviousRiskProfiles] = useState<RiskProfile[]>([]);

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")

  const isDigitalOnboarding = `${application?.onboardingVia ?? ""}`.toLowerCase() === "digital"

  const handleSubmit = async (values: Values) => {
    try {
      const {
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const {
        riskprofiles,
        riskProfileDeclaration,
        wishToAddRiskProfile,
        totalRiskProfileScore = 0,
        saveType,
      } = values;
      // Only validate active profiles — inactive profiles (from old riskProfileGroup) should not block submission
      const checkAllQuestionsAnswered = riskprofiles
        ?.filter((profile) => profile.isActive !== false)
        ?.map((profile) => profile.answer !== '' && profile.required === 'true')
        ?.every((_profile) => _profile);
      if (!wishToAddRiskProfile && !checkAllQuestionsAnswered) {
        throw 'Please fill all the required(*) fields';
      }
      if (!wishToAddRiskProfile && !values.riskProfileGroup) {
        throw 'Please select a Question Set'
      }
      if (!wishToAddRiskProfile && !values.riskProfileDeclarationDate) {
        throw 'Declaration date is required'
      }
      if (!wishToAddRiskProfile && !isDateInRange(values.riskProfileDeclarationDate ?? dayjs(), dayjs("1900-01-01"), dayjs())) {
        throw "Declaration date should be less than or equal to today's date"
      }
      if (!wishToAddRiskProfile && !values.riskProfileExpiryDate) {
        throw 'Expiry date is required'
      }
      if (!wishToAddRiskProfile && !isDateInRange(values.riskProfileExpiryDate ?? dayjs(), dayjs(), dayjs("2099-12-31"))) {
        throw "Expiry date should be greater than or equal to today's date"
      }

      //  Only validate "others" text field for active profiles
      riskprofiles?.filter((risk) => risk.isActive !== false)?.map((risk) => {
        if (
          !wishToAddRiskProfile &&
          (risk.answer === 'others' ||
            (risk.isMultiselect === 'true' && risk.answer.includes('others'))) &&
          !risk.otherValue &&
          risk.required === 'true'
        ) {
          const questionForDisplay = riskProfileDataMaster
            ?.map((riskProfile) => {
              if (riskProfile.key === risk.question) {
                return riskProfile.displayText;
              }
              return;
            })
            ?.filter((ele) => ele)
            ?.toString();
          throw 'Please specify others in ' + questionForDisplay;
        }
      });
      if (!wishToAddRiskProfile && !riskProfileDeclaration) {
        throw 'Declaration is required';
      }
      const updatedRiskProfile = riskprofiles?.map((_riskProfile) => {
        const {
          otherValue,
          required,
          values,
          displayText,
          key,
          isMultiselect,
          totalPercentage,
          InvestmentGoal,
          scoreCal,
          questionType,
          ...rest
        } = _riskProfile;
        return {
          ...rest,
          // Include isActive in the payload sent to backend (defaults to true)
          isActive: _riskProfile.isActive ?? true,
          answer:
            otherValue && rest.answer === 'others'
              ? otherValue
              : isMultiselect === 'true' && otherValue && rest.answer?.includes('others')
                ? rest.answer?.replace('others', otherValue)
                : rest.answer,
        };
      });
      const updatedPayload = {
        ...application,
        totalRiskProfileScore: wishToAddRiskProfile ? 0 : Number(manageTotal(values).toFixed(1)),
        wishToAddRiskProfile,
        riskProfileDeclaration,
        riskProfile: wishToAddRiskProfile ? null : application?.riskProfile,
        riskProfileDeclarationDate: wishToAddRiskProfile ? null : values?.riskProfileDeclarationDate?.toISOString(),
        riskProfileExpiryDate: wishToAddRiskProfile ? null : values?.riskProfileExpiryDate?.toISOString(),
        riskProfileGroup: wishToAddRiskProfile ? null : values.riskProfileGroup,
        // Send the whole riskprofiles array (both isActive true and false) to the backend
        // When wishToAddRiskProfile is true, mark all saved profiles as inactive; otherwise send all profiles as-is
        riskprofiles: wishToAddRiskProfile
          ? updatedRiskProfile && updatedRiskProfile?.length > 0
            ? (updatedRiskProfile
              ?.map((_profile) => {
                if (_profile.id) {
                  return {
                    ..._profile,
                    isActive: false,
                  };
                }
                return;
              })
              .filter((ele) => ele) as updatedRiskProfile[])
            : updatedRiskProfile?.filter((profile) => profile.answer)
          : updatedRiskProfile,
      };
      const checkApplication = applicationComparison(
        {
          ...application,
          riskprofiles: application?.riskprofiles?.sort(
            (riskprofile1, riskprofile2) => Number(riskprofile1.id) - Number(riskprofile2.id)
          ),
        },
        {
          ...updatedPayload,
          riskprofiles: updatedPayload?.riskprofiles?.sort(
            (riskprofile1, riskprofile2) => Number(riskprofile1.id) - Number(riskprofile2.id)
          ),
          currentStep: !!currentStep && currentStep > (ONBOARDING_DEMAT_DETAILS ? 9 : 8) ? currentStep : Number(currentStep) + 1,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';

      let currentStatus = status

      if (
        !isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
        status === 'sent_to_amc_approver'
      ) {
        currentStatus = 'draft'
      } else if (
        !hasPOA &&
        AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
        status !== 'draft' &&
        applyRoleBasedStatus(role)
      ) {
        currentStatus = 'sent_to_amc_approver'
      }

      if (id && !checkApplication) {
        setLoading(true);
        const response = await dispatch(
          updateApplication({
            body: {
              ...updatedPayload,
              status: currentStatus,
              currentStep: (ONBOARDING_DEMAT_DETAILS ? 10 : 9),
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );

        if (!response) return

        !isSaveLater
          ? history.push('investment-preference', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('investment-preference', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        if (Object.keys(application ?? {}).length > 0) {
          setApiLoading(true)

          const riskProfileGroupsResponse = (await dispatch(getRiskProfileGroups())) as unknown as RiskProfileGroup[];

          setQuestionSetList(riskProfileGroupsResponse ?? [])

          const response = (await dispatch(riskProfileMasterData({
            riskProfileGroup: application?.riskProfileGroup ?
              application?.riskProfileGroup :
              (isDigitalOnboarding ?
                ((riskProfileGroupsResponse ?? []).find(obj => obj.key === "NEXEDGE_IND")?.key ?? null) :
                (riskProfileGroupsResponse?.[0]?.key ?? null)
              ),
            company: application?.company ?? null
          }))) as unknown as RiskProfileMaster;
          if (!isComponentAlive) {
            return;
          }
          setRiskProfileDataMaster(response.riskProfile);
          setProfileData(response.profile);
          const {
            riskprofiles = [],
            riskProfileDeclaration = true,
            wishToAddRiskProfile = true,
          } = application || {};

          // Store the original riskProfileGroup for detecting group switches during edit
          const appRiskProfileGroup = application?.riskProfileGroup ? application?.riskProfileGroup : (isDigitalOnboarding ?
            ((riskProfileGroupsResponse ?? []).find(obj => obj.key === "NEXEDGE_IND")?.key ?? "") :
            (riskProfileGroupsResponse?.[0]?.key ?? "")
          )

          setOriginalRiskProfileGroup(appRiskProfileGroup);

          // Store existing riskprofiles from application to preserve them (as inactive) during group switches
          setPreviousRiskProfiles(riskprofiles);

          // Determine if this is the first time visiting this screen (no saved riskprofiles yet)
          const isFirstTime = !riskprofiles || riskprofiles.length === 0;

          setRiskProfileData({
            ...riskProfileData,
            wishToAddRiskProfile: wishToAddRiskProfile || false,
            riskProfileDeclaration: wishToAddRiskProfile ? false : riskProfileDeclaration || true,
            riskProfileGroup: appRiskProfileGroup,
            riskProfileDeclarationDate: application?.riskProfileDeclarationDate ? dayjs(application.riskProfileDeclarationDate) : dayjs(todayDate),
            riskProfileExpiryDate: application?.riskProfileExpiryDate ? dayjs(application.riskProfileExpiryDate) : dayjs(oneYearAhead),
            riskprofiles: response.riskProfile
              ?.map((mdmsProfile) => {
                const existingRiskProfiles = riskprofiles?.filter(
                  (risk_profiles) => risk_profiles.question === mdmsProfile.key
                );
                return existingRiskProfiles.length
                  ? existingRiskProfiles?.map((existingProfiles) => {
                    if (
                      existingProfiles.question === mdmsProfile.key &&
                      mdmsProfile.isMultiselect === 'true'
                    ) {
                      const getInvestment = handleIntialSelect(riskprofiles, mdmsProfile.key);
                      const checkAnswerArray = mdmsProfile.values?.map((_value) => _value.key);
                      let getOtherValue = '';
                      const updateOptions = getInvestment.map((ans) => {
                        if (!checkAnswerArray?.includes(ans.split('_')[0])) {
                          getOtherValue = ans.split('_')[0];
                          return `others_${ans.split('_')[1]}`;
                        }
                        return ans;
                      });
                      return {
                        ...existingProfiles,
                        ...mdmsProfile,
                        // First time → isActive true; editing → preserve existing isActive from saved data
                        isActive: isFirstTime ? true : (existingProfiles.isActive ?? true),
                        values: mdmsProfile.values?.map((value) => {
                          const scoreUpdate = updateOptions
                            .find((investment) => investment?.split('_')[0] === value.key)
                            ?.split('_')[1];

                          return {
                            ...value,
                            score: scoreUpdate ? Number(scoreUpdate) : value.score,
                          };
                        }),
                        InvestmentGoal: updateOptions || [],
                        scoreCal: Number(existingProfiles.scoreText) || 0,
                        otherValue: getOtherValue,
                        answer: getOtherValue
                          ? updateOptions?.toString()?.replace(/,/g, '*')
                          : existingProfiles.answer,
                        questionText: mdmsProfile?.displayText ?? "",
                        answerText: mdmsProfile?.values?.find((obj: { [key: string]: any }) => obj?.key === existingProfiles?.answer)?.label ?? ""
                      };
                    } else {
                      const checkAnswer =
                        existingProfiles.question === mdmsProfile.key &&
                        mdmsProfile.isMultiselect === 'false' &&
                        mdmsProfile.values
                          ?.map((value) => value.key)
                          .includes(existingProfiles.answer);

                      return {
                        ...existingProfiles,
                        ...mdmsProfile,
                        // First time → isActive true; editing → preserve existing isActive from saved data
                        isActive: isFirstTime ? true : (existingProfiles.isActive ?? true),
                        values: mdmsProfile.values?.map((value) => {
                          if (existingProfiles.answer === value.key) {
                            return {
                              ...value,
                              score: Number(existingProfiles.scoreText),
                            };
                          }
                          return value;
                        }),
                        otherValue: checkAnswer ? '' : existingProfiles.answer,
                        answer: checkAnswer ? existingProfiles.answer : 'others',
                        questionText: mdmsProfile?.displayText ?? "",
                        answerText: mdmsProfile?.values?.find((obj: { [key: string]: any }) => obj?.key === existingProfiles?.answer)?.label ?? ""
                      };
                    }
                  })
                  : [
                    {
                      ...RiskProfileObj,
                      question: mdmsProfile.key,
                      //  New questions (first time or no existing match) are always active
                      isActive: true,
                      answer:
                        wishToAddRiskProfile === null && mdmsProfile.key === 'age'
                          ? getRiskAgeValue(
                            getAge(
                              application?.applicants?.find(
                                (_applicant) => _applicant.applicant_type === '1'
                              )?.dateOfBirth
                            )
                          )
                          : '',
                      scoreText:
                        wishToAddRiskProfile === null && mdmsProfile.key === 'age'
                          ? getScore(
                            getRiskAgeValue(
                              getAge(
                                application?.applicants?.find(
                                  (_applicant) => _applicant.applicant_type === '1'
                                )?.dateOfBirth
                              )
                            )
                          )
                          : '',
                      ...mdmsProfile,
                      questionText: mdmsProfile?.displayText ?? ""
                    },
                  ];
              })
              .flat(),
          });
        }
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        setApiLoading(false)
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, [application]);

  const manageTotal = (values: Values) => {
    // Only calculate total score from active profiles (inactive profiles from old groups should not count)
    const total = values.riskprofiles
      .filter((risk) => risk.isActive !== false)
      .map((risk) => {
        return Number(risk.scoreText);
      })
      .reduce(function (acc, val) {
        return acc + val;
      }, 0);

    return total;
  };

  const getLatestRiskProfile = async (
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<Values>>, selectedRiskProfileGroup: string) => {
    try {
      setApiLoading(true)

      setFieldValue('riskProfileGroup', selectedRiskProfileGroup);

      const response = (await dispatch(riskProfileMasterData({
        riskProfileGroup: selectedRiskProfileGroup ?? null,
        company: application?.company ?? null
      }))) as unknown as RiskProfileMaster;

      setRiskProfileDataMaster(response.riskProfile);
      setProfileData(response.profile);

      const {
        riskprofiles = [],
        wishToAddRiskProfile = true,
        riskProfileGroup
      } = application || {};

      /**
       * isActive logic for riskProfileGroup switch:
       * - If user switches back to originalRiskProfileGroup → reversal: restore isActive true for original questions
       * - If user changes to a different group → mark old group questions isActive: false, new group questions isActive: true
       * - If group is not changed → edit in the same question set (isActive remains true)
       */
      const isSwitchingBackToOriginal = selectedRiskProfileGroup === originalRiskProfileGroup;
      const isGroupChanged = selectedRiskProfileGroup !== riskProfileGroup;

      // Build the inactive profiles from the previous group (only those already saved with an id)
      let inactiveProfiles: updatedRiskProfile[] = [];
      if (isGroupChanged && !isSwitchingBackToOriginal) {
        inactiveProfiles = previousRiskProfiles
          ?.filter((profile) => profile.id)
          ?.map((profile) => ({
            ...RiskProfileObj,
            ...profile,
            isActive: false,
          })) ?? [];
      }

      const newRiskProfiles = response?.riskProfile
        ?.map((mdmsProfile) => {
          let existingRiskProfiles: RiskProfile[] = []

          // If switching back to original group or group unchanged, restore/use existing answers with isActive: true
          if (isSwitchingBackToOriginal || riskProfileGroup === selectedRiskProfileGroup) {
            existingRiskProfiles = riskprofiles?.filter(
              (risk_profiles) => risk_profiles.question === mdmsProfile.key
            );
          }

          return existingRiskProfiles.length
            ? existingRiskProfiles?.map((existingProfiles) => {
              if (
                existingProfiles.question === mdmsProfile.key &&
                mdmsProfile.isMultiselect === 'true'
              ) {
                const getInvestment = handleIntialSelect(riskprofiles, mdmsProfile.key);
                const checkAnswerArray = mdmsProfile.values?.map((_value) => _value.key);
                let getOtherValue = '';
                const updateOptions = getInvestment.map((ans) => {
                  if (!checkAnswerArray?.includes(ans.split('_')[0])) {
                    getOtherValue = ans.split('_')[0];
                    return `others_${ans.split('_')[1]}`;
                  }
                  return ans;
                });
                return {
                  ...existingProfiles,
                  ...mdmsProfile,
                  // Current group's questions are always active (whether switching back to original or editing same group)
                  isActive: true,
                  values: mdmsProfile.values?.map((value) => {
                    const scoreUpdate = updateOptions
                      .find((investment) => investment?.split('_')[0] === value.key)
                      ?.split('_')[1];

                    return {
                      ...value,
                      score: scoreUpdate ? Number(scoreUpdate) : value.score,
                    };
                  }),
                  InvestmentGoal: updateOptions || [],
                  scoreCal: Number(existingProfiles.scoreText) || 0,
                  otherValue: getOtherValue,
                  answer: getOtherValue
                    ? updateOptions?.toString()?.replace(/,/g, '*')
                    : existingProfiles.answer,
                  questionText: mdmsProfile?.displayText ?? "",
                  answerText: mdmsProfile?.values?.find((obj: { [key: string]: any }) => obj?.key === existingProfiles?.answer)?.label ?? ""
                };
              } else {
                const checkAnswer =
                  existingProfiles.question === mdmsProfile.key &&
                  mdmsProfile.isMultiselect === 'false' &&
                  mdmsProfile.values
                    ?.map((value) => value.key)
                    .includes(existingProfiles.answer);

                return {
                  ...existingProfiles,
                  ...mdmsProfile,
                  // Current group's questions are always active
                  isActive: true,
                  values: mdmsProfile.values?.map((value) => {
                    if (existingProfiles.answer === value.key) {
                      return {
                        ...value,
                        score: Number(existingProfiles.scoreText),
                      };
                    }
                    return value;
                  }),
                  otherValue: checkAnswer ? '' : existingProfiles.answer,
                  answer: checkAnswer ? existingProfiles.answer : 'others',
                  questionText: mdmsProfile?.displayText ?? "",
                  answerText: mdmsProfile?.values?.find((obj: { [key: string]: any }) => obj?.key === existingProfiles?.answer)?.label ?? ""
                };
              }
            })
            : [
              {
                ...RiskProfileObj,
                question: mdmsProfile.key,
                //  New questions for the newly selected group are always active
                isActive: true,
                answer:
                  wishToAddRiskProfile === null && mdmsProfile.key === 'age'
                    ? getRiskAgeValue(
                      getAge(
                        application?.applicants?.find(
                          (_applicant) => _applicant.applicant_type === '1'
                        )?.dateOfBirth
                      )
                    )
                    : '',
                scoreText:
                  wishToAddRiskProfile === null && mdmsProfile.key === 'age'
                    ? getScore(
                      getRiskAgeValue(
                        getAge(
                          application?.applicants?.find(
                            (_applicant) => _applicant.applicant_type === '1'
                          )?.dateOfBirth
                        )
                      )
                    )
                    : '',
                ...mdmsProfile,
                questionText: mdmsProfile?.displayText ?? ""
              },
            ];
        })
        .flat()

      /**
       * Combine active profiles (new group) + inactive profiles (old group) for the API payload
       * - When switching back to original group: no inactive needed (original questions become active again — reversal)
       * - When switching to a new group: append old group profiles as inactive so backend receives full picture
       */
      const combinedRiskProfiles = isSwitchingBackToOriginal
        ? newRiskProfiles
        : [...newRiskProfiles, ...inactiveProfiles];

      setFieldValue("riskprofiles", combinedRiskProfiles);

    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setApiLoading(false)
    }
  }

  const handleDateChange = (date: any, fieldName: string, setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<Values>>) => {
    let modifiedDate = date;

    if (modifiedDate) {
      const currentTime = dayjs();

      modifiedDate = modifiedDate
        ?.hour(currentTime.hour())
        ?.minute(currentTime.minute())
        ?.second(currentTime.second())
    }

    setFieldValue(fieldName, modifiedDate)
  }

  return (
    <Formik
      initialValues={riskProfileData}
      // validationSchema={riskProfileScheme}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, setFieldValue }) => (
        <Grid
          container
          rowSpacing={0.5}
          columnSpacing={3}
          // sx={{
          //   width: '100%',
          //   ml: 0,
          //   '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          // }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <Grid item xs={12}>

            <Grid xs={12} sx={{ mb: 2 }}>
              <MFCheckbox
                name="wishToAddRiskProfile"
                label={riskProfileDonotWish}
                sx={{ display: 'flex', alignItems: 'flex-start', fontFamily: `${theme.typography.fontFamily}` }}
                onChange={({ target: { checked } }) => {
                  const updatedRiskProfile = riskProfileDataMaster.map((mdmsProfile) => {
                    const riskObj = values.riskprofiles?.find(
                      (_profile) => _profile.key === mdmsProfile.key
                    );
                    return {
                      ...RiskProfileObj,
                      question: mdmsProfile.key,
                      ...riskObj,
                      answer:
                        mdmsProfile.key === 'age'
                          ? getRiskAgeValue(
                            getAge(
                              application?.applicants?.find(
                                (_applicant) => _applicant.applicant_type === '1'
                              )?.dateOfBirth
                            )
                          )
                          : '',
                      scoreText:
                        mdmsProfile.key === 'age'
                          ? getScore(
                            getRiskAgeValue(
                              getAge(
                                application?.applicants?.find(
                                  (_applicant) => _applicant.applicant_type === '1'
                                )?.dateOfBirth
                              )
                            )
                          )
                          : '',
                      ...mdmsProfile,
                    };
                  });
                  !checked &&
                    setValues({
                      ...values,
                      wishToAddRiskProfile: checked,
                      riskProfileDeclaration: values.riskProfileDeclaration || true,
                      riskprofiles: [...updatedRiskProfile],
                    });
                  checked && setOpenPopup({ riskProfileCheck: checked });
                }}
                checked={values.wishToAddRiskProfile}
                disabled={isApiLoading}
              />
            </Grid>

            <Grid
              container
              spacing={2}
              sx={{
                marginBottom: 2,
                alignItems: "center",
              }}
            >
              <Grid
                item
                xs={12}
                lg={4}
              >
                <MFSelectField
                  name="riskProfileGroup"
                  label="Question Set *"
                  items={questionSetList
                    ?.filter((obj) => {
                      if (isDigitalOnboarding) {
                        return obj.key === "NEXEDGE_IND"
                      }

                      return true
                    })
                    .map(({ key, value }) => ({
                      key,
                      value
                    }))}
                  sx={{
                    "&.MuiOutlinedInput-root": {
                      "& fieldset>legend": {
                        fontSize: "0.78em",
                      }
                    }
                  }}
                  disabled={isApiLoading || values.wishToAddRiskProfile}
                  onChange={(event) => {
                    getLatestRiskProfile(setFieldValue, `${event.target.value}`)
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                lg={4}
              >
                <TextDatePicker
                  name="riskProfileDeclarationDate"
                  label="Declaration Date *"
                  inputLabelStyles={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                  }}
                  placeholder=''
                  disabled={isApiLoading || values.wishToAddRiskProfile}
                  customHandleChange={(date: any) => handleDateChange(date, "riskProfileDeclarationDate", setFieldValue)}
                />
              </Grid>
              <Grid
                item
                xs={12}
                lg={4}
              >
                <TextDatePicker
                  name="riskProfileExpiryDate"
                  label="Expiration Date *"
                  inputLabelStyles={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                  }}
                  placeholder=''
                  disabled={isApiLoading || values.wishToAddRiskProfile}
                  minDate={todayDate}
                  maxDate={new Date("2099-12-31")}
                  customHandleChange={(date: unknown) => handleDateChange(date, "riskProfileExpiryDate", setFieldValue)}
                />
              </Grid>
            </Grid>

            {/*  Only render active profiles in the UI — inactive profiles (from old group) are hidden but still part of the form state */}
            <RiskDeclaration
              data={values.riskprofiles.filter((profile) => profile.isActive !== false)}
              values={values}
              setValues={setValues}
              setTotalScore={setTotalScore}
              totalScore={totalScore}
              disabled={values.wishToAddRiskProfile || isApiLoading}
            />
            <Box
              component={'section'}
              aria-label="Risk profile score summary"
              aria-live="polite"
              aria-atomic="true"
              style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}
            >
              <Box
                role="status"
                tabIndex={0}
                sx={{ backgroundColor: `${theme.palette.success[800]}`, padding: '10px 20px', borderRadius: '5px' }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 500,
                    fontSize: 16,
                    letterSpacing: '0.2px',
                    fontFamily: `${theme.typography.fontFamily}`
                  }}>{`Your total Score : ${manageTotal(values)}`}
                </Typography>
              </Box>
              {Number(manageTotal(values)) > 0 && <Box
                role="status"
                tabIndex={0}
                aria-label="Risk profile result"
                sx={{ backgroundColor: `${theme.palette.warning[800]}`, padding: '10px 20px', borderRadius: '5px' }}
              >


                {profiletext(Number(manageTotal(values)), profileData)}


              </Box>}
            </Box>
          </Grid>
          <Grid item xs={12} my={2}>
            <MFCheckbox
              name={`riskProfileDeclaration`}
              label={riskProfileDeclaration}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                color: `${theme.palette.text.primary}`,
                "& :disabled": {
                  color: `${theme.palette.text.secondary}`,
                }
              }}
              disabled={values.wishToAddRiskProfile || isApiLoading}

            />
          </Grid>
          <Grid item xs={12} my={2} />
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
            showEndIcon={false}
            saveButtonText='Continue'
            disabled={isApiLoading}
          />
          <ConfirmationDialog
            message={`Skip Risk Profiling`}
            subMessage='Are you sure you do not wish to undergo the RISK Profiling ?'
            open={openPopup !== null}
            setOpen={() => {
              setOpenPopup(null);
            }}
            onSave={() => {
              setValues({
                ...values,
                wishToAddRiskProfile: openPopup?.riskProfileCheck as boolean,
                riskProfileDeclaration: false,
                riskprofiles: values.riskprofiles?.map((_profile) => {
                  return {
                    ..._profile,
                    answer: '',
                    scoreText: '',
                    InvestmentGoal: [],
                    scoreCal: 0,
                  };
                }),
              });
              setOpenPopup(null);
            }}
            onCancel={() => {
              setOpenPopup(null);
            }}
            showIcon
          />
        </Grid>
      )}
    </Formik>
  );
}
